import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// SELDON_BEATTIE_UPLOAD_ATTACHMENT

const mutation = gql`
  mutation wellnessSeldonBeattieFormUploadAttachment(
    $id: ID!
    $attachment: AnnualPhysicalFormAttachmentInput!
  ) {
    wellnessSeldonBeattieFormUploadAttachment(
      form_id: $id
      attachment: $attachment
    ) {
      id
      form_attachment {
        id
      }
    }
  }
`

export default function useWellnessUploadAttachment() {
  const { onMutate: onWellnessAttachmentUpload, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'wellnessSeldonBeattieFormUploadAttachment',
    successMessage: 'Attachment uploaded'
  })

  return { onWellnessAttachmentUpload, loading }
}
